import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const REDIRECT_DELAY_MS = 3000;

export default function BillingCancelPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home", { replace: true });
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FDF8F5] px-6 text-center">
      <div className="w-full max-w-sm rounded-[1.8rem] border border-[#EADBC8] bg-white px-8 py-10 shadow-[0_16px_40px_rgba(166,124,82,0.12)]">
        <p className="text-4xl">✕</p>
        <h1 className="mt-4 text-lg font-black text-[#5D4D46]">お手続きをキャンセルしました</h1>
        <p className="mt-3 text-sm font-medium leading-6 text-[#7B6861]">まもなくホームに戻ります。</p>
      </div>
    </div>
  );
}
